import axios from "axios";

//API Base Url
const BASEURL = 'https://api.oblivious.ai/hackathon';


export const client = axios.create({
    baseURL: BASEURL
});